export const GET_VISITS = 'visits/GET_VISITS'
export const GET_VISITS_SUCCESS = 'visits/GET_VISITS_SUCCESS'
export const GET_VISITS_ERROR = 'visits/GET_VISITS_ERROR'

export const GET_REMARKS = 'visits/GET_REMARKS'
export const GET_REMARKS_SUCCESS = 'visits/GET_REMARKS_SUCCESS'
export const GET_REMARKS_ERROR = 'visits/GET_REMARKS_ERROR'

export const GET_VISIT_INFO = 'visits/GET_VISIT_INFO'
export const GET_VISIT_INFO_SUCCESS = 'visits/GET_VISIT_INFO_SUCCESS'
export const GET_VISIT_INFO_ERROR = 'visits/GET_VISIT_INFO_ERROR'

export const START_INPERSON_VISIT = 'visits/START_INPERSON_VISIT'
export const START_INPERSON_VISIT_SUCCESS = 'visits/START_INPERSON_VISIT_SUCCESS'
export const START_INPERSON_VISIT_ERROR = 'visits/START_INPERSON_VISIT_ERROR'

export const DELETE_VISIT_REMARK = 'chartPage/DELETE_VISIT_REMARK'
export const DELETE_VISIT_REMARK_SUCCESS = 'chartPage/DELETE_VISIT_REMARK_SUCCESS'
export const DELETE_VISIT_REMARK_ERROR = 'chartPage/DELETE_VISIT_REMARK_ERROR'

export const UPDATE_UPCOMING_VISIT_REMARK = 'chartPage/UPDATE_UPCOMING_VISIT_REMARK'
export const UPDATE_UPCOMING_VISIT_REMARK_SUCCESS = 'chartPage/UPDATE_UPCOMING_VISIT_REMARK_SUCCESS'
export const UPDATE_UPCOMING_VISIT_REMARK_ERROR = 'chartPage/UPDATE_UPCOMING_VISIT_REMARK_ERROR'

export const SET_VISIT_ERROR = 'visits/SET_VISIT_ERROR'
export const SET_EDIT_REMARK_ID = 'chartPage/SET_EDIT_REMARK_ID'
export const SET_DELETE_REMARK_ID = 'chartPage/SET_DELETE_REMARK_ID'

export const CLEAR_VISIT_DATA = 'visits/CLEAR_VISIT_DATA'

export const REMOVE_VISIT_ITEM_BY_ID = 'visits/REMOVE_VISIT_ITEM_BY_ID'

export const SET_CANCELLED_VISIT_ID = 'visits/SET_CANCELLED_VISIT_ID'
export const CLEAR_CANCELLED_VISIT_ID = 'visits/CLEAR_CANCELLED_VISIT_ID'
